/**
 * Formats a number as Indian Rupee (INR) currency.
 *
 * @param {number} amount - The amount to format
 * @param {string} locale - Locale string (default: 'en-IN' for Indian number formatting)
 * @param {Object} options - Additional Intl.NumberFormat options to override defaults
 * @returns {string} Formatted currency string e.g. ₹1,00,000.00
 */
export const currencyFormat = (amount, locale = "en-IN", options = {}) => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
    ...options,
  }).format(amount);
};
